import { Controller } from "@hotwired/stimulus"

// Declarative client-side PostHog capture.
//
// Use for pure UI interactions that the server does not see (view toggles, tab
// switches, opening a modal, expanding a panel). For anything that hits the
// server, prefer backend tracking via PosthogTracking (full Current context).
//
// Usage in a view:
//   <button data-controller="analytics"
//           data-action="click->analytics#capture"
//           data-analytics-event-param="task_modal_opened"
//           data-analytics-props-param='{"source":"kanban"}'>
//
// The "feature" and "action" properties are filled in automatically on the
// server side for backend events; for client events we send them as-is, so
// include them in props when a unified breakdown is needed.
export default class extends Controller {
  capture(event) {
    const el = event.currentTarget
    const name = el.dataset.analyticsEventParam
    if (!name) return

    let props = {}
    const raw = el.dataset.analyticsPropsParam
    if (raw) {
      try {
        props = JSON.parse(raw)
      } catch (e) {
        console.warn("[analytics] invalid props JSON", raw)
      }
    }

    this.send(name, props)
  }

  // Programmatic helper other controllers can import-free reach via the global.
  send(name, props = {}) {
    if (typeof window.phCapture === "function") {
      window.phCapture(name, props)
    }
  }
}
